var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCetegory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01E30F5F-65C2-4323-8C57-6989869712A3@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google-TV",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Operatory-Room-NAV",
    transform: "translate(-90.000000, -554.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Operatory-room-menu"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.26,
    fill: "#000000",
    x: 0,
    y: 0,
    width: 430,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(90.000000, 210.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Specializations/White-Copy",
    transform: "translate(0.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,20 C15.5522847,20 16,20.4477153 16,21 L16,35 C16,35.5522847 15.5522847,36 15,36 L1,36 C0.44771525,36 6.76353751e-17,35.5522847 0,35 L0,21 C-6.76353751e-17,20.4477153 0.44771525,20 1,20 L15,20 Z M35,20 C35.5522847,20 36,20.4477153 36,21 L36,35 C36,35.5522847 35.5522847,36 35,36 L21,36 C20.4477153,36 20,35.5522847 20,35 L20,21 C20,20.4477153 20.4477153,20 21,20 L35,20 Z M15,0 C15.5522847,-1.01453063e-16 16,0.44771525 16,1 L16,15 C16,15.5522847 15.5522847,16 15,16 L1,16 C0.44771525,16 6.76353751e-17,15.5522847 0,15 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L15,0 Z M35,0 C35.5522847,-1.01453063e-16 36,0.44771525 36,1 L36,15 C36,15.5522847 35.5522847,16 35,16 L21,16 C20.4477153,16 20,15.5522847 20,15 L20,1 C20,0.44771525 20.4477153,1.01453063e-16 21,0 L35,0 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCetegory);
export default __webpack_public_path__ + "static/media/ic_cetegory.d63f487f.svg";
export { ForwardRef as ReactComponent };